import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import CoverUploader from './ImageUpload/CoverUploader';
import LogoUploader from './ImageUpload/LogoUploader';
import { API_ENDPOINTS } from 'http-client/httpConstants';

interface EditBusinessSettingsMediaProps {
  id: string;
  name: string;
  logoUrl: string;
  coverImageUrl: string;
}

const EditBusinessSettingsMedia: React.FC<EditBusinessSettingsMediaProps> = ({
  id,
  name,
  logoUrl,
  coverImageUrl,
}) => {
  const [currentLogoUrl, setCurrentLogoUrl] = useState<string>(logoUrl);
  const [currentCoverUrl, setCurrentCoverUrl] = useState<string>(coverImageUrl);

  useEffect(() => {
    setCurrentLogoUrl(logoUrl);
  }, [logoUrl]);

  useEffect(() => {
    setCurrentCoverUrl(coverImageUrl);
  }, [coverImageUrl]);

  return (
    <Card className="shadow-sm">
      <CardBody>
        <CoverUploader
          shopId={id}
          coverImageUrl={currentCoverUrl}
          uploadUrl={API_ENDPOINTS.TENANT.BUSINESS.UPLOAD_IMAGE(id)}
          invalidateQueryKey={[API_ENDPOINTS.TENANT.BUSINESS.GET_BY_ID, { id }]}
          onUploaded={(url) => setCurrentCoverUrl(url)}
        />

        <Row className="align-items-center mt-4">
          <Col md="8" sm="12" className="d-flex align-items-center">
            <div className="me-3" style={{ flexShrink: 0 }}>
              <LogoUploader
                shopId={id}
                logoUrl={currentLogoUrl}
                uploadUrl={API_ENDPOINTS.TENANT.BUSINESS.UPLOAD_IMAGE(id)}
                invalidateQueryKey={[API_ENDPOINTS.TENANT.BUSINESS.GET_BY_ID, { id }]}
                onUploaded={(url) => setCurrentLogoUrl(url)}
              />
            </div>
            <div>
              <h2 className="mb-1">{name}</h2>
              <p className="text-muted mb-0">Update your business logo and cover image here.</p>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default EditBusinessSettingsMedia;
